import { Layout as AntdLayout } from 'antd'
import { styled } from 'styled-components'
import { SMALL_LAYOUT_MAX_WIDTH } from './constants'

export const Layout = styled(AntdLayout)`
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
`

export const Content = styled(Layout.Content)`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  // skip header height
  padding: calc(89px + 12px) 0 0;

  @media (max-width: ${SMALL_LAYOUT_MAX_WIDTH}) {
    // skip header height + safe area
    padding: calc(64px + env(safe-area-inset-top, 0)) 0 0;
  }
`
